<template>
  <v-container fluid fill-height>
    <v-row class="mx-sm-2 mt-xs-1">
      <v-col>
        <v-img
          :src="$vuetify.theme.dark ? $appConfig.customerLogoDarkUri : $appConfig.customerLogoUri"
          :max-width="$appConfig.customerLogoWidth + 'px'"
          :max-height="$appConfig.customerLogoHeight + 'px'"
        ></v-img>
        <div v-translate class="text-h3 py-3">
          Caller Verify - Error
        </div>

        <div class="py-4">
          <translate>An application error has occurred.</translate><br/>
        </div>

        <v-alert
          outlined
          type="error"
          id="cv_error"
        >
        {{ $gettext(error.title) }} - {{ error.param ? $gettextInterpolate($gettext(error.description), {errorParam: error.param}) : $gettext(error.description) }}
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'ErrorPage',

  data: () => ({
    error: {
      title: 'Unknown Error',
      description: 'An unknown error has occurred.',
      param: null
    }
  }),

  methods: {
    parseErrorParameters: function() {
      let params = new URLSearchParams(window.location.search);

      let title = params.get('error');
      let description = params.get('error_description');

      // optional parameter to pass through translation layer without translating.
      let err_param = params.get('error_param');

      if (title !== null) {
        this.error.title = title;
      }
      if (description !== null) {
        this.error.description = description;
      }
      if(err_param !== null) {
        this.error.param = err_param;
      }
    }
  },
  mounted() {
    // Load the error and description from the URL query
    this.parseErrorParameters();
  }
}
</script>

<style scoped>
</style>
